import React, { useState, useEffect } from 'react';
import OTPInput from 'react-otp-input';
import useAxiosFetchData from '../../hooks/useAxiosFetchData';
import { apiHostUrl, applicationContextRoot, regenarateOtpForMfa, submitOtpForMfa } from '../../../constants/constants';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { InputLabel, TextField, Stack } from '@mui/material';
import Button from 'react-bootstrap/Button';
import {t} from 'i18next';

export default function MultiFactorAuthentication(props) {
  const { csrfToken } = useSelector((state) => state.csrf);
  const { homeLink } = useSelector((state) => state.role);
  const [headers] = useState({
    "X-Csrf-Token": csrfToken,
    "Content-Type": "application/json",
  });
  const navigate = useNavigate();
  const [{ otp, numInputs, separator, minLength, maxLength, placeholder, inputType }, setConfig] = useState({
    otp: {
      otpValue: ''
    },
    numInputs: 6,
    separator: '   ',
    minLength: 0,
    maxLength: 40,
    placeholder: '',
    inputType: 'text',
  });

  const [otpPayload, setOtpPayload] = useState({
    otpValue: otp
  });

  const [timer, setTimer] = useState(180000); // Timer starts at 18000 ms
  const [isResendDisabled, setIsResendDisabled] = useState(true);

  useEffect(() => {
    if (timer > 0) {
      const timerId = setTimeout(() => setTimer(timer - 1000), 1000);
      return () => clearTimeout(timerId);
    } else {
      setIsResendDisabled(false);
    }
  }, [timer]);

  const handleOTPChange = (otp) => {
    setConfig((prevConfig) => ({
      ...prevConfig,
      otp: {
        ...prevConfig.otp,
        otpValue: otp
      }
    }));
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setConfig((prevConfig) => ({ ...prevConfig, [name]: value }));
  };

  const handleNumInputsChange = (event) => {
    let numInputs = event.target.valueAsNumber;

    if (numInputs < minLength || numInputs > maxLength) {
      numInputs = 4;

      console.error(`Please enter a value between ${minLength} and ${maxLength}`);
    }

    setConfig((prevConfig) => ({ ...prevConfig, numInputs }));
  };

  const clearOtp = () => {
    setConfig((prevConfig) => ({ ...prevConfig, otp: '' }));
  };

  const { fetchData: submitOtpMethod } = useAxiosFetchData({
    url: apiHostUrl + homeLink + submitOtpForMfa,
    method: 'post',
    body: otp,
    headers: headers,
    onLoad: false,
  });

  const { fetchData: resendOtpMethod } = useAxiosFetchData({
    url: apiHostUrl + homeLink + regenarateOtpForMfa,
    method: 'post',
    body: otp,
    headers: headers,
    onLoad: false,
  });

  const handleSubmit = (event) => {
    event.preventDefault();
    submitOtpMethod()
      .then((response) => {
        //const responsead = response.request.responseURL;
        debugger;
        if (response && response?.message && response.success === false) {
          props.onErrorFromLogin(response.message);
        } else if (response && response?.message) {
          props.onErrorFromLogin(response.message);
        } else {
          //navigate(applicationContextRoot + '/home');
          window.location.reload();
        }
        console.log(response);
      })
      .catch((error) => console.log(error));
  };

  const handleRegenarateOtp = (event) => {
    event.preventDefault();
    resendOtpMethod().then((response) => {
      console.log(response);
      setTimer(180000); // Reset the timer
      setIsResendDisabled(true);
      if (response && response?.message) {
        props.onErrorFromLogin(response.message);
      }
    });
  };

  const formatTime = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };

  return (

    <form onSubmit={handleSubmit}>

      <InputLabel className='fw-medium form-label text-black' htmlFor="outlined-adornment-password">{t('general.label.enter.verification.code')}</InputLabel>
      {/* <Stack direction="row" spacing={2}>
        <TextField type="number" variant="outlined" sx={{ '& input': { textAlign: 'center' } }} />
        <TextField type="number" variant="outlined" sx={{ '& input': { textAlign: 'center' } }} />
        <TextField type="number" variant="outlined" sx={{ '& input': { textAlign: 'center' } }} />
        <TextField type="number" variant="outlined" sx={{ '& input': { textAlign: 'center' } }} />
        <TextField type="number" variant="outlined" sx={{ '& input': { textAlign: 'center' } }} />
        <TextField type="number" variant="outlined" sx={{ '& input': { textAlign: 'center' } }} />
      </Stack> */}
      <OTPInput
                inputStyle="inputStyle"
                numInputs={numInputs}
                onChange={handleOTPChange}
                renderSeparator={<span>{separator}</span>}
                value={otp.otpValue}
                placeholder={placeholder}
                inputType={inputType}
                renderInput={(props) => <input {...props} />}
                shouldAutoFocus
              />

      <Stack className="timer" direction="row" spacing={2} sx={{ mt: 2 }} justifyContent="space-between" alignItems={'center'}>
        <span>
        {isResendDisabled && <p className='m-0'>{t('general.label.resend.otp.in')} {formatTime(timer)}</p>}
        </span>
        <Button variant="link" disabled={isResendDisabled} onClick={handleRegenarateOtp} className='p-0 fw-medium'>{t('general.label.resend.otp')}</Button>
      </Stack>
      <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
        
        <Button className='w-100' type="submit" variant="primary" disabled={otp.otpValue.length < numInputs}>{t('general.button.submit.label')}</Button>
        {/* <button
          className="btn margin-top--large"
          type="button"
          disabled={isResendDisabled}
          onClick={handleRegenarateOtp}
        >
          Resend Otp
        </button> */}
        {/* <Button size='lg' variant="primary" disabled={otp.otpValue.length < numInputs}>
          Submit
        </Button> */}

      </Stack>
    </form>


  );
}
